/**
 * تسجيلُ المكالمةِ في التطبيقِ والصفحةُ في المتصفّح.
 *
 * المتصفّحُ لا يعطي صوتَ النظامِ إلّا خلفَ نافذةِ «اختر ما تشاركه» ولا
 * يحفظُ الإذنَ بين الجلسات، فموظّفٌ يعمل من كروم يُسأل كلَّ يوم. وحين
 * يكونُ التطبيقُ عاملًا على الجهازِ نفسِه فالأذنُ حاضرة: يسجّلُ هو عبر
 * منفذِه المحلّيّ، ويعيدُ الصوتَ إلى هذه الصفحةِ لترفعَه **بجلستِها**.
 *
 * فالتطبيقُ لا يحمل رمزَ دخولٍ ولا يعرفُ مستخدمًا ولا يكلّم الخادم —
 * وحدودُ ما يفعله: يسمع، ويسلّم ما سمعه لمن طلبه.
 */

const LOCAL_BRIDGE = 'http://127.0.0.1:47831/phone';

interface Reply {
  ok: boolean;
  error?: string;
  audio?: string;
  mime?: string;
}

/**
 * مهلةٌ سخيّةٌ لإغلاقِ التسجيل: يكتبُ آخرَ قطعةٍ ويُرمّز الصوتَ كلَّه.
 * والبدءُ قد يتلكّأ بقدرِ ما يستيقظُ مخرجُ الصوت.
 */
async function send(cmd: string, timeoutMs = 30_000): Promise<Reply> {
  try {
    const r = await fetch(LOCAL_BRIDGE, {
      method: 'POST',
      headers: { 'content-type': 'application/json', 'x-goyone': '1' },
      body: JSON.stringify({ cmd: `rec:${cmd}`, args: {} }),
      signal: AbortSignal.timeout(timeoutMs),
    });
    if (!r.ok) return { ok: false, error: `bridge ${r.status}` };
    return (await r.json()) as Reply;
  } catch {
    /* التطبيقُ أُغلق في أثناء الوردية — يُقال لا لا أن يُرمى خطأ. */
    return { ok: false, error: 'unreachable' };
  }
}

export const deskRecorder = {
  start: () => send('start'),
  stop: () => send('stop', 5_000),
  beginCall: () => send('callStart', 10_000),
  /** يُنهي التسجيلَ ويعيدُ الصوتَ — أو لا شيءَ إن لم يُسجَّل. */
  endCall: async (): Promise<Blob | null> => {
    const reply = await send('callStop');
    if (!reply.ok || !reply.audio) return null;
    const binary = atob(reply.audio);
    const bytes = new Uint8Array(binary.length);
    for (let i = 0; i < binary.length; i += 1) bytes[i] = binary.charCodeAt(i);
    return new Blob([bytes], { type: reply.mime ?? 'audio/webm' });
  },
};
